import React from "react";
import { motion } from "framer-motion";
import { Clock, TrendingUp, Users } from "lucide-react";
import quickcaptionGif from "../assets/quickcaptionnobg.PNG"; // make sure path is correct

export default function About() {
  const benefits = [
    { icon: <Clock className="w-6 h-6 text-indigo-500" />, title: "Time-saving" },
    { icon: <TrendingUp className="w-6 h-6 text-indigo-500" />, title: "Increase Engagement" },
    { icon: <Users className="w-6 h-6 text-indigo-500" />, title: "Boost Reach" },
  ];

  return (
    <section
      id="about"
      className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 flex flex-col md:flex-row items-center gap-12"
    >
      {/* Text content */}
      <div className="w-full md:w-1/2 z-10">
        <motion.h2
          className="text-3xl sm:text-4xl font-bold mb-6 text-slate-900 dark:text-white"
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          What is QuickCaptionIO?
        </motion.h2>
        <motion.p
          className="text-lg text-slate-700 dark:text-slate-300 mb-8"
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          QuickCaptionIO helps creators turn random words into meaningful captions and trending hashtags.  
          Save time, increase engagement, and boost your reach effortlessly with AI-powered content generation.
        </motion.p>

        {/* Benefits */}
        <motion.div
          className="grid grid-cols-1 sm:grid-cols-3 gap-4"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          {benefits.map((benefit, idx) => (
            <div
              key={idx}
              className="flex flex-col items-center bg-indigo-50 dark:bg-gray-800 rounded-xl p-4 hover:scale-105 hover:shadow-lg transition-transform duration-300"
            >
              <div className="mb-2">{benefit.icon}</div>
              <h4 className="font-semibold text-slate-900 dark:text-white">
                {benefit.title}
              </h4>
            </div>
          ))}
        </motion.div>
      </div>

      {/* Illustration / Decorative shapes */}
      <div className="w-full md:w-1/2 relative flex justify-center items-center">
        {/* Decorative blobs */}
        <motion.div
          className="absolute w-64 h-64 bg-gradient-to-tr from-indigo-400 via-pink-400 to-yellow-400 rounded-full filter blur-3xl opacity-30 animate-blob"
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 0.3, scale: 1 }}
          transition={{ duration: 1 }}
        />
        <motion.div
          className="absolute w-40 h-40 bg-pink-300 rounded-full filter blur-2xl opacity-30 top-20 right-16 animate-blob animation-delay-2000"
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 0.3, scale: 1 }}
          transition={{ duration: 1, delay: 0.3 }}
        />

        {/* QuickCaption GIF above circle */}
        <motion.img
          src={quickcaptionGif}
          alt="QuickCaption Animation"
          className="absolute w-20 h-30 -translate-x-1/2 w-44 md:w-60 z-20"
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 5 }}
        />

   
      </div>
    </section>
  );
}
